// SAB-578: single source of truth for the marketing "trash scoring" example.
// The live ScoreboardPanel card and the Week 1 example line both read from this,
// so they can never drift apart again. The total is DERIVED by summing the
// subtotals, never hard-coded.
//
// Per-event points are the REAL live scoring weights, verified against prod
// nfl_scoring_model version 2.2 (is_active = true):
//   Interception thrown +10 · Sack taken +3 · Fumble lost +10 (fumble +5 plus
//   lost-fumble extra +5) · Individual penalty +2.
// If the active scoring model version changes, re-check these values against it or
// the marketing page will drift from the product.
//
// Canonical line: 3 INT thrown, 4 sacks taken, 1 fumble lost, 4 offensive penalties.

export interface TrashEvent {
  label: string;      // live-card row label, e.g. "Interceptions thrown"
  statNoun: string;   // Week 1 stat-line noun, e.g. "INT" -> "3 INT"
  detail?: string;    // live-card subtext, e.g. "3 this game"
  each: number;       // points per event
  count: number;      // number of events
}

export const TRASH_EXAMPLE: TrashEvent[] = [
  { label: 'Interceptions thrown', statNoun: 'INT',                 detail: '3 this game', each: 10, count: 3 },
  { label: 'Sacks taken',          statNoun: 'sacks taken',         detail: '4 this half', each: 3,  count: 4 },
  { label: 'Fumble lost',          statNoun: 'fumble lost',                                each: 10, count: 1 },
  { label: 'Penalties',            statNoun: 'offensive penalties', detail: '4 flags',     each: 2,  count: 4 },
];

/** Points contributed by one event row (each * count). */
export const trashSubtotal = (e: TrashEvent) => e.each * e.count;

/** Derived grand total (summed, not hard-coded). Currently 60. */
export const TRASH_TOTAL = TRASH_EXAMPLE.reduce((sum, e) => sum + trashSubtotal(e), 0);

/** Week 1 compact stat line, e.g. "3 INT · 4 sacks taken · 1 fumble lost · 4 offensive penalties". */
export const trashStatLine = TRASH_EXAMPLE.map((e) => `${e.count} ${e.statNoun}`).join(' · ');
